import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountSandbox } from 'src/core/account/account.sandbox';
import { USER_ROLES } from 'src/core/helpers/constants.enum';

@Component({
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, OnDestroy {
    private subs: Subscription[] = [];

    USER_ROLES = USER_ROLES;
    currentUserRole: string = null;

    constructor(
        private cd: ChangeDetectorRef,
        private accountSandbox: AccountSandbox,
    ) { }

    ngOnInit(): void {
        this.accountSandbox.doGetUsetsList({});

        this.subs.push(this.accountSandbox.currentUserRole$.subscribe(role => {
            // console.log(role);
            this.currentUserRole = role;
            this.cd.markForCheck();
        }));

        this.subs.push(this.accountSandbox.getUsersListData$.subscribe(res => {
            console.log(res);
        }))
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}

